export default {
  methods: {
    appHomeBack: function () {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.homeBack()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.homeBack.postMessage('')
      }
    },
    /**
     * イベントトラッキング：ページビュー(PVset)
     * @param {string} screenName スクリーン名
     */
    nativePVset: function (screenName) {
      const json = JSON.stringify({ SHOWPAGE: screenName })
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.PVSet(json)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.PVSet.postMessage(json)
      }
    },
    /**
     * イベントトラッキング：イベント送信(EVENTSet)
     * @param {string} eventName イベント名（パラメータ名）
     * @param {string} buttonName ボタン名
     * @param {string} actionName アクション名（Value）
     * @param {string} customParameters カスタム パラメータ（array）
     */
    nativeEVENTSet: function (eventName, buttonName, actionName, customParameters) {
      /** ネイティブへ渡す形式
      {
        "EVENTNAME": "PushSettinsButton",  //イベント名
        "PUSH_ON": "TAP"  //ボタン名：アクション名
      }
      */
      // キーに変数の値を使うため、ブラケット表記でjsonを設定
      let json = ''
      const baseJson = {
        EVENTNAME: eventName
      }
      baseJson[buttonName] = actionName
      if (customParameters) {
        for (const key in customParameters) {
          baseJson[key] = customParameters[key]
        }
      }
      json = JSON.stringify(baseJson)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.EVENTSet(json)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.EVENTSet.postMessage(json)
      }
    },
    /**
     * 戻るボタン出し分けのfunction
     * @param {boolean}
     */
    appDisplayBack: function (bool) {
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.displayBack(bool)
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.displayBack.postMessage(bool)
      }
    }
  }
}
